import React, { useRef } from 'react';
import { isEmpty, noop } from 'lodash';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Loader } from '@fiverr-private/fit';
import { Stepper } from '@fiverr-private/orca';
import { BODY_STEPS, STEPS } from '../../../constants';
import { useShouldOfferMoreGigs, useShouldEncourageAppDownload } from '../../../hooks';
import MessageSent from '../../MessageSent';
import SendMessage from '../../SendMessage';
import { useOfferMoreGigsContext } from '../../OfferMoreGigs/context';
import {
    shouldShowBrief,
    shouldShowVacationMessage,
    useStaticContext
} from '../../../context/contexts/static';
import { allocateToMoreGigsV4Experiment } from '../../../utils/moreGigs';
import { VacationMessage } from '../ContactSellerDrawer/VacationMessage';
import { GenerateBrief } from '../ContactSellerDrawer/GenerateBrief';
import classes from './style.module.scss';

const PopupBody = ({ onClose, drawerView, onSubmitSuccess, onSubmitFailure, onStepChange = noop }) => {
    const { shouldShowMoreGigsV3, shouldShowMoreGigsV4 } = useShouldOfferMoreGigs();
    const { inFmpMoreGigsV4Rollout } = useStaticContext();
    const shouldEncourageAppDownload = useShouldEncourageAppDownload();
    const { offerMoreGigsComponentRef, gigs, setShowMoreGigsStep } = useOfferMoreGigsContext();
    const context = useStaticContext();

    const shouldEncourageAppDownloadRef = useRef(false);

    const selectStep = (step, navigateById) => {
        beforeStepChange(step);
        onStepChange(step);
        navigateById(step);
    };

    const beforeStepChange = (step) => {
        if (step === STEPS.THANK_YOU) {
            shouldEncourageAppDownloadRef.current = shouldEncourageAppDownload;
        }
    };

    const shouldShowOfferMoreGigs = () => {
        if (shouldShowMoreGigsV4 && allocateToMoreGigsV4Experiment(inFmpMoreGigsV4Rollout)){
            return true;
        }
        return shouldShowMoreGigsV3;
    };

    const onMessageFormSubmit = (navigateById) => async() => {
        selectStep(STEPS.LOADING, navigateById);

        if (offerMoreGigsComponentRef.current && !isEmpty(gigs) && shouldShowOfferMoreGigs() && !drawerView) {
            setShowMoreGigsStep(true);
            selectStep(STEPS.OFFER_MORE_GIGS, navigateById);
        } else {
            selectStep(STEPS.THANK_YOU, navigateById);
        }

        onSubmitSuccess();
    };

    const OfferMoreGigs = offerMoreGigsComponentRef.current;
    const shouldShowHeader = shouldShowBrief(context) || shouldShowVacationMessage(context);

    return (
        <Stepper steps={BODY_STEPS} initialStepId={STEPS.MESSAGE_FORM}>
            <Stepper.Step stepId={STEPS.MESSAGE_FORM}>
                {({ navigateById }) => (
                    <div className={classNames(classes.stepWrapper)}>
                        {drawerView && shouldShowHeader && <div className={classes.drawerPadding}>
                            <VacationMessage/>
                            <GenerateBrief onClose={onClose}/>
                        </div>}
                        <SendMessage onSubmitSuccess={onMessageFormSubmit(navigateById)}
                            drawerView={drawerView}
                            onSubmitFailure={onSubmitFailure}/>
                    </div>
                )}
            </Stepper.Step>

            <Stepper.Step stepId={STEPS.LOADING}>
                <div className={classes.stepWrapper}>
                    <div className={classes.loadingStep}>
                        <Loader size={Loader.SIZES.LG}/>
                    </div>
                </div>
            </Stepper.Step>

            <Stepper.Step stepId={STEPS.THANK_YOU}>
                <div className={classes.stepWrapper}>
                    <MessageSent onClose={onClose}
                        drawerView={drawerView}
                        showAppDownloadQr={shouldEncourageAppDownloadRef.current}/>
                </div>
            </Stepper.Step>

            <Stepper.Step stepId={STEPS.OFFER_MORE_GIGS}>
                {({ navigateById }) => (
                    <OfferMoreGigs onSubmit={() => selectStep(STEPS.THANK_YOU, navigateById)}/>
                )}
            </Stepper.Step>
        </Stepper>
    );
};

PopupBody.propTypes = {
    onClose: PropTypes.func,
    onSubmitSuccess: PropTypes.func,
    onSubmitFailure: PropTypes.func,
    onStepChange: PropTypes.func,
    drawerView: PropTypes.bool
};

export default PopupBody;
